export default __webpack_public_path__ + "static/media/shoppinglist_male@2x.b2d01b8b.png";